const fmtNumber = (n) => (n || 0).toLocaleString();

const BUCKET_META = [
  { key: 'reach', label: 'Reach', color: '#0EA5E9' },
  { key: 'activity', label: 'Activity', color: '#F59E0B' },
  { key: 'creation', label: 'Creation', color: '#22C55E' },
  { key: 'participation', label: 'Participation', color: '#8B5CF6' }
];

/**
 * One dot per bucket that has at least one event, labelled with its count — reads as "what kind
 * of engagement" without a legend row or a second grid of numbers to scan.
 *
 * Shared by the module's item list and the drawer's people list, which are the same idea one
 * level apart: a row of bucket counts for a thing. Colours must stay in step with
 * `BUCKET_COLORS` in `ItemActivityDrawer.js`, which tints the timeline's own dots.
 */
const BucketDots = ({ row }) => {
  const active = BUCKET_META.filter((b) => row[b.key] > 0);
  if (!active.length) return null;

  return (
    <div className="flex items-center gap-2.5 mt-1 flex-wrap">
      {active.map(({ key, label, color }) => (
        <span key={key} className="flex items-center gap-1">
          <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: color }} />
          <span className="text-[11px] text-[#94A3B8]">
            {label} {fmtNumber(row[key])}
          </span>
        </span>
      ))}
    </div>
  );
};

export default BucketDots;
